import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const StyledButtonsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
`;

export const StyledButtonCard = styled(Link)`
    background: #eee;
    border-radius: 0.25rem;
    padding: 1rem;
    aspect-ratio: 3 / 1;
    
    p {
        
    }
`;